import React, { useState, useEffect, useRef } from 'react';
import { styles, colors } from '../../styles/globalStyles';

export const ModalEditarVaga = ({
  modalEditarVaga,
  buscaAluno,
  setBuscaAluno,
  alunos,
  setAlunos,
  buscarAlunos,
  setModalEditarVaga,
  handleSalvarEdicaoVaga,
  onLimparVaga,
  isMobile
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingLimpar, setLoadingLimpar] = useState(false);
  const [confirmandoLimpar, setConfirmandoLimpar] = useState(false);
  const skipSearchRef = useRef(false);
  const [formData, setFormData] = useState({
    descricao: '',
    aluno_fixo_id: '',
    trancada: false,
    rascunho: false,
    // data_hora intencionalmente ausente: não editamos o horário da vaga aqui
  });

  useEffect(() => {
    if (modalEditarVaga) {
      setFormData({
        descricao:     modalEditarVaga.descricao || '',
        aluno_fixo_id: modalEditarVaga.aluno_fixo_id || '',
        trancada:      modalEditarVaga.trancada || false,
        rascunho:      modalEditarVaga.rascunho || false,
      });
      skipSearchRef.current = true;
      setBuscaAluno(modalEditarVaga.aluno_fixo_nome || '');
      setConfirmandoLimpar(false);
    }
  }, [modalEditarVaga, setBuscaAluno]);

  useEffect(() => {
    if (skipSearchRef.current) {
      skipSearchRef.current = false;
      return;
    }
    if (buscaAluno) {
      const timer = setTimeout(() => {
        buscarAlunos(buscaAluno);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setAlunos([]);
    }
  }, [buscaAluno, buscarAlunos, setAlunos]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await handleSalvarEdicaoVaga({ ...modalEditarVaga, ...formData });
    } finally {
      setLoading(false);
    }
  };

  const handleLimpar = async () => {
    if (!confirmandoLimpar) {
      setConfirmandoLimpar(true);
      return;
    }
    setLoadingLimpar(true);
    try {
      await onLimparVaga(modalEditarVaga.id);
    } finally {
      setLoadingLimpar(false);
      setConfirmandoLimpar(false);
    }
  };

  if (!modalEditarVaga) return null;

  const podeLimpar = !!(modalEditarVaga.agendamento_id || modalEditarVaga.aluno_fixo_id);
  const dataVaga = modalEditarVaga.data_hora ? new Date(modalEditarVaga.data_hora) : null;

  const btnBase = {
    ...styles.button,
    fontSize: isMobile ? '0.75rem' : '0.875rem',
    padding: isMobile ? '0.5rem 0.75rem' : '0.625rem 1.25rem',
    whiteSpace: 'nowrap'
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={{
        ...styles.modalContent,
        maxWidth: isMobile ? '100%' : '500px',
        margin: isMobile ? '0.5rem' : undefined
      }}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>Editar Vaga</h2>
          <button
            onClick={() => setModalEditarVaga(null)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: colors.gray
            }}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} style={styles.modalBody}>
          {/* Informações da Vaga */}
          <div style={{
            backgroundColor: colors.grayLight,
            padding: '1rem',
            borderRadius: '0.5rem',
            marginBottom: '1.5rem'
          }}>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <div>
                <strong style={{ fontSize: '0.875rem', color: colors.gray }}>ID:</strong>
                <div style={{ fontWeight: '600' }}>{modalEditarVaga.id}</div>
              </div>
              {dataVaga && (
                <div>
                  <strong style={{ fontSize: '0.875rem', color: colors.gray }}>Data/Hora:</strong>
                  <div style={{ fontWeight: '600' }}>
                    {dataVaga.toLocaleDateString('pt-BR')} {dataVaga.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              )}
              <div>
                <strong style={{ fontSize: '0.875rem', color: colors.gray }}>Identificação:</strong>
                <div style={{ fontWeight: '700', color: '#1e293b' }}>
                  Vaga {modalEditarVaga.numero_vaga || '—'}
                </div>
              </div>
              <div>
                <strong style={{ fontSize: '0.875rem', color: colors.gray }}>Status:</strong>
                <div>
                  <span style={{
                    ...styles.badge,
                    ...(modalEditarVaga.trancada ? styles.badgeDanger :
                         modalEditarVaga.rascunho ? styles.badgeWarning :
                         modalEditarVaga.aluno_fixo_id ? styles.badgeWarning :
                         modalEditarVaga.agendamento_id ? styles.badgeInfo : styles.badgeSuccess)
                  }}>
                    {modalEditarVaga.trancada ? 'Trancada' :
                     modalEditarVaga.rascunho ? 'Rascunho' :
                     modalEditarVaga.aluno_fixo_id ? 'Fixa' :
                     modalEditarVaga.agendamento_id ? 'Agendada' : 'Disponível'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Aluno Agendado */}
          {modalEditarVaga.aluno_nome && (
            <div style={{
              backgroundColor: '#f0f9ff',
              border: '1px solid #bae6fd',
              padding: '1rem',
              borderRadius: '0.5rem',
              marginBottom: '1.25rem'
            }}>
              <strong style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                Aluno Agendado:
              </strong>
              <div style={{ fontWeight: '600' }}>{modalEditarVaga.aluno_nome}</div>
              <div style={{ fontSize: '0.875rem', color: colors.gray }}>
                {modalEditarVaga.aluno_email}
              </div>
            </div>
          )}

          {/* Campos do Formulário */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Anotações <span style={{ fontWeight: 400, color: '#94a3b8', fontSize: '0.8rem' }}>(visível só para admin/professor)</span></label>
            <textarea
              value={formData.descricao}
              onChange={(e) => setFormData(prev => ({ ...prev, descricao: e.target.value }))}
              style={{
                ...styles.formInput,
                minHeight: '80px',
                resize: 'vertical'
              }}
              placeholder="Ex: aula experimental, reposição, visitante..."
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Aluno Fixo</label>
            <input
              type="text"
              value={buscaAluno}
              onChange={(e) => setBuscaAluno(e.target.value)}
              style={styles.formInput}
              placeholder="Buscar aluno..."
            />

            {alunos.length > 0 && (
              <div style={{
                marginTop: '0.5rem',
                border: `1px solid ${colors.grayLight}`,
                borderRadius: '0.5rem',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                {alunos.map(aluno => (
                  <div
                    key={aluno.id}
                    onClick={() => {
                      setFormData(prev => ({ ...prev, aluno_fixo_id: aluno.id }));
                      setBuscaAluno(aluno.nome);
                      setAlunos([]);
                    }}
                    style={{
                      padding: '0.75rem',
                      cursor: 'pointer',
                      borderBottom: `1px solid ${colors.grayLight}`
                    }}
                  >
                    <div style={{ fontWeight: '600' }}>{aluno.nome}</div>
                    <div style={{ fontSize: '0.875rem', color: colors.gray }}>{aluno.email}</div>
                  </div>
                ))}
              </div>
            )}

            {formData.aluno_fixo_id && (
              <div style={{
                marginTop: '0.5rem',
                padding: '0.5rem',
                backgroundColor: colors.grayLight,
                borderRadius: '0.5rem',
                fontSize: '0.875rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span>
                  Fixo: {alunos.find(a => a.id === formData.aluno_fixo_id)?.nome || buscaAluno || 'Selecionado'}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    setFormData(prev => ({ ...prev, aluno_fixo_id: '' }));
                    setBuscaAluno('');
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: colors.gray,
                    fontSize: '1rem',
                    padding: '0 0.25rem'
                  }}
                  title="Remover aluno fixo"
                >
                  ×
                </button>
              </div>
            )}
          </div>

          <div style={styles.formGroup}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input
                type="checkbox"
                checked={formData.trancada}
                onChange={(e) => setFormData(prev => ({ ...prev, trancada: e.target.checked }))}
                style={{ width: '1rem', height: '1rem' }}
              />
              <span>Trancar vaga (impedir agendamentos)</span>
            </label>
          </div>

          <div style={styles.formGroup}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input
                type="checkbox"
                checked={formData.rascunho}
                onChange={(e) => setFormData(prev => ({ ...prev, rascunho: e.target.checked }))}
                style={{ width: '1rem', height: '1rem' }}
              />
              <span>Manter como rascunho (invisível para alunos)</span>
            </label>
          </div>
        </form>

        <div style={{
          ...styles.modalFooter,
          justifyContent: podeLimpar ? 'space-between' : 'flex-end',
          flexWrap: 'wrap',
          gap: '0.5rem'
        }}>
          {/* Botão Limpar — lado esquerdo, só aparece quando há algo a limpar */}
          {podeLimpar && (
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              {confirmandoLimpar ? (
                <>
                  <button
                    type="button"
                    onClick={handleLimpar}
                    disabled={loadingLimpar}
                    style={{
                      ...btnBase,
                      ...styles.buttonDanger,
                      opacity: loadingLimpar ? 0.7 : 1,
                      cursor: loadingLimpar ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {loadingLimpar ? 'Limpando...' : '✓ Confirmar limpeza'}
                  </button>
                  <button
                    type="button"
                    onClick={() => setConfirmandoLimpar(false)}
                    disabled={loadingLimpar}
                    style={{ ...btnBase, ...styles.buttonOutline }}
                  >
                    ← Voltar
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  onClick={handleLimpar}
                  style={{ ...btnBase, ...styles.buttonDanger }}
                  title="Remove o agendamento atual e o aluno fixo, deixando a vaga livre"
                >
                  🧹 Limpar Vaga
                </button>
              )}
            </div>
          )}

          {/* Botões direita: Cancelar + Salvar */}
          {!confirmandoLimpar && (
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button
                type="button"
                onClick={() => setModalEditarVaga(null)}
                style={{ ...btnBase, ...styles.buttonOutline }}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  ...btnBase,
                  ...styles.buttonPrimary,
                  opacity: loading ? 0.7 : 1,
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
